/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './progress-box.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../src/app/progress/progress-box.component';
const styles_ProgressBoxComponent:any[] = [i0.styles];
export const RenderType_ProgressBoxComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ProgressBoxComponent,data:{}});
function View_ProgressBoxComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'progressMarker'],['id','progressMarker']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class','coloredProgressMarker'],
          ['id','coloredProgressMarker']],[[4,'background',(null as any)]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted((null as any),['\n    ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.getColor(_v.context.$implicit);
        _ck(_v,2,0,currVal_0);
      });
}
export function View_ProgressBoxComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'markersContainer'],['id','markersContainer']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ProgressBoxComponent_1)),
      i1.ɵdid(802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i3.ProgressBoxComponent = _v.component;
    const currVal_0:any = _co.markers;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
export function View_ProgressBoxComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'progress-box',
      ([] as any[]),(null as any),(null as any),(null as any),View_ProgressBoxComponent_0,
      RenderType_ProgressBoxComponent)),i1.ɵdid(114688,(null as any),0,i3.ProgressBoxComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ProgressBoxComponentNgFactory:i1.ComponentFactory<i3.ProgressBoxComponent> = i1.ɵccf('progress-box',
    i3.ProgressBoxComponent,View_ProgressBoxComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL3Byb2dyZXNzL3Byb2dyZXNzLWJveC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvcHJvZ3Jlc3MvcHJvZ3Jlc3MtYm94LmNvbXBvbmVudC50cyIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL3Byb2dyZXNzL3Byb2dyZXNzLWJveC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL3Byb2dyZXNzL3Byb2dyZXNzLWJveC5jb21wb25lbnQudHMuUHJvZ3Jlc3NCb3hDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGlkPVwibWFya2Vyc0NvbnRhaW5lclwiIGNsYXNzPVwibWFya2Vyc0NvbnRhaW5lclwiPlxuICAgIDxkaXYgaWQ9XCJwcm9ncmVzc01hcmtlclwiIGNsYXNzPVwicHJvZ3Jlc3NNYXJrZXJcIiAqbmdGb3I9XCJsZXQgbWFya2VyIG9mIG1hcmtlcnNcIj5cbiAgICAgICAgPGRpdiBpZD1cImNvbG9yZWRQcm9ncmVzc01hcmtlclwiIGNsYXNzPVwiY29sb3JlZFByb2dyZXNzTWFya2VyXCIgW3N0eWxlLmJhY2tncm91bmRdPVwiZ2V0Q29sb3IobWFya2VyKVwiPlxuICAgICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbjwvZGl2PiIsIjxwcm9ncmVzcy1ib3g+PC9wcm9ncmVzcy1ib3g+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7OztvQkNDSTtNQUFBO01BQUEsOEJBQStFO01BQzNFO1VBQUE7VUFBQSw0Q0FBb0c7VUFBQSxpQkFDOUY7OztRQUR3RDtRQUE5RCxXQUE4RCxTQUE5RDs7OztvQkFGUjtNQUFBO01BQUEsOEJBQW9ELDJDQUNoRDthQUFBO2FBQUE7NEJBQUEseUNBR007VUFBQTs7SUFIMEM7SUFBaEQsV0FBZ0QsU0FBaEQ7Ozs7b0JDREo7TUFBQTtxQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./aot_output/src/app/progress/progress-box.component.ngfactory.ts